import { getSettings } from '../settings';

const isGalleryItem = (node) => {
  const settings = getSettings();
  return node.matches(settings.galleryItem);
};

export default isGalleryItem;
